import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  ShippingTruckIcon,
  GlobeAltIcon,
  KeyIcon,
  InboundIcon,
  WarehouseIcon,
  PackageIcon,
  BuildingOffice2Icon,
  CustomerIcon,
  UserCogIcon,
} from '../components/common/Icons';
import { useAppAuth } from '../contexts/AppAuthContext';
import { SyncStatusProvider } from '../contexts/SyncStatusContext';
import { SyncStatusSidebar } from '../components/sync/SyncStatusSidebar';

const menuItems = [
  { path: '/shipping', label: '発送予定', icon: ShippingTruckIcon },
  { path: '/supplier-share', label: '仕入先共有', icon: GlobeAltIcon },
  { path: '/supplier-management', label: '仕入先認証管理', icon: KeyIcon },
  { path: '/inbound-schedule', label: '入荷予定', icon: InboundIcon },
  { path: '/inventory', label: '在庫一覧', icon: WarehouseIcon },
  { path: '/nisugata', label: '荷姿管理', icon: PackageIcon },
  { path: '/customer-order-history', label: '得意先別実績', icon: CustomerIcon },
  { path: '/customer-info', label: '顧客情報', icon: BuildingOffice2Icon },
  { path: '/users', label: 'ユーザー管理', icon: UserCogIcon, adminOnly: true },
];

const AppShellInner = ({ children }) => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window === 'undefined') return true;
    return window.innerWidth > 1366;
  });
  const { user, isAdmin, logout } = useAppAuth();

  return (
    <div className="flex h-screen bg-slate-50 app-shell-root">
      <div className={`${sidebarOpen ? 'w-64' : 'w-16'} bg-slate-900 text-slate-100 transition-all duration-300 flex flex-col shadow-lg print:hidden`}>
        <div className="p-4 border-b border-slate-700 flex items-center justify-between">
          <h1 className={`${sidebarOpen ? 'block' : 'hidden'} text-lg font-semibold tracking-wide text-slate-100`}>資材Web</h1>
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="text-slate-400 hover:text-slate-100 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        <nav className="flex-1 overflow-y-auto py-4">
          {menuItems.filter((item) => !item.adminOnly || isAdmin).map((item) => {
            const isActive = location.pathname === item.path;
            const IconComponent = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center px-4 py-3 transition-colors ${
                  isActive
                    ? 'bg-slate-800 border-l-4 border-slate-400 text-slate-50'
                    : 'text-slate-300 hover:bg-slate-800 hover:text-slate-50'
                }`}
              >
                <IconComponent className="w-5 h-5 flex-shrink-0" />
                {sidebarOpen && (
                  <span className="ml-3 text-sm font-medium">{item.label}</span>
                )}
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-slate-700 text-sm text-slate-300">
          <SyncStatusSidebar sidebarOpen={sidebarOpen} />
          {sidebarOpen && user && (
            <div className="mb-2">
              <div className="font-medium text-slate-100">{user.display_name}</div>
              <div className="text-xs text-slate-400">{user.login_id}</div>
            </div>
          )}
          <button
            type="button"
            onClick={() => logout()}
            className="text-slate-400 hover:text-slate-100 text-xs underline"
          >
            ログアウト
          </button>
        </div>
      </div>

      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <div className="flex-1 overflow-y-auto app-shell-main">
          {children}
        </div>
      </div>
    </div>
  );
};

export const AppShell = ({ children }) => (
  <SyncStatusProvider>
    <AppShellInner>{children}</AppShellInner>
  </SyncStatusProvider>
);
